import React from 'react' 
import LandLeaseDetails from 'src/modules/SubServices/LandLease/LandLeaseDetails' 
 
type Props = {} 
 
const LandLeasePage = (props: Props) => { 
    return ( 
        <div> 
            <LandLeaseDetails /> 
        </div> 
    ) 
} 
 
export default LandLeasePage 
